import { render, staticRenderFns } from "./game_switch.vue?vue&type=template&id=53b21711&scoped=true&"
import script from "./game_switch.vue?vue&type=script&lang=js&"
export * from "./game_switch.vue?vue&type=script&lang=js&"
import style0 from "./game_switch.vue?vue&type=style&index=0&id=53b21711&lang=less&scoped=true&"
import style1 from "./game_switch.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b21711",
  null
  
)

export default component.exports